import { render, staticRenderFns } from "./BankAccountsTable.vue?vue&type=template&id=a23617aa"
import script from "./BankAccountsTable.vue?vue&type=script&lang=js"
export * from "./BankAccountsTable.vue?vue&type=script&lang=js"
import style0 from "./BankAccountsTable.vue?vue&type=style&index=0&id=a23617aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports